export enum CompanyRatingBlock {
  Root = 'CompanyRating',
}
